module.exports = __webpack_public_path__ + "img/inbox.5df2d56c.svg";